import { render, staticRenderFns } from "./AppSettingsForm.vue?vue&type=template&id=54cad262&"
import script from "./AppSettingsForm.vue?vue&type=script&lang=js&"
export * from "./AppSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports